import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

function FileCardSkeleton() {
  return (
    <div className="relative flex flex-col h-full border border-border rounded-lg overflow-hidden bg-white dark:bg-background">
      {/* Thumbnail area - matches FileGridItemShell */}
      <div className="relative">
        <Skeleton className="w-full aspect-video bg-white dark:bg-white" />
      </div>

      {/* Content area - matches FileGridItemShell padding and structure */}
      <div className="p-3 flex-grow flex flex-col">
        {/* Title - matches h3 with line-clamp-2, leading-snug, min-h-[2.5rem] */}
        <Skeleton className="h-3.5 w-[90%] mb-1" />
        <Skeleton className="h-3.5 w-[70%] mb-1.5" />

        {/* Date - matches text-xs at bottom (mt-auto equivalent) */}
        <div className="mt-auto">
          <Skeleton className="h-3 w-[50%]" />
        </div>
      </div>
    </div>
  );
}

export default FileCardSkeleton;
